<template>
  <div class="box8">
    <div class="titleContent">
      优势三
      <p>项目硬</p>
    </div>
    <pageTitle
      title="3大企业级项目<br/>20+实战案例 项目经验"
      titleColor="#24375C"
    />

    <div class="subject-box">
      <div class="nav-box">
        <div
          class="nav"
          :class="{ 'cur-nav': cur == index }"
          v-for="(item, index) in projectList"
          :key="index"
          @click="changeCur(index)"
        >
          {{ item.num }}
        </div>
      </div>

      <div @click="showPop">
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          class="swiperitems"
          @slideChange="slideChange()"
        >
          <swiper-slide
            class="swiperwrap"
            v-for="(item, index) in projectList"
            :key="index"
          >
            <div class="wrap">
              <img class="img" :src="item.img" alt="" />
              <div class="projectName">
                <p>{{ item.name }}</p>
              </div>

              <div class="projectDesc">{{ item.txt }}</div>
              <div class="btn">查看全部</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>

    <van-popup
      v-model="show"
      position="bottom"
      round
      :style="{ maxHeight: '15rem' }"
    >
      <div class="block">
        <div class="block-tops">
          <div class="title">{{ projectList[this.cur].name }}</div>
          <div class="close" @click="show = false"></div>
        </div>
        <div class="intro">{{ projectList[this.cur].txt }}</div>

        <div class="tag">学习收获</div>
        <div class="target">
          <p>{{ projectList[this.cur].lightPoint }}</p>
        </div>
      </div>
    </van-popup>
    <box9 />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import box9 from "./Box9.vue";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
    box9,
  },
  mounted() {},

  data() {
    let that = this;
    return {
      show: false,

      projectList: [
        {
          num: "项目一",
          img: require("../../../assets/coursePage/dataAnalysis/box8/2.png"),
          name: "金融风控",
          txt: "金融风控项目将带领学员搭建整套金融风控知识体系，并介绍反欺诈、信用分风险策略、评分卡模型构建等热点知识。项目中还会详细讲解金融大赛的优胜解决方案。",
          lightPoint: "· 学后可具备初中级金融风控分析师的能力。",
        },
        {
          num: "项目二",
          img: require("../../../assets/coursePage/dataAnalysis/box8/3.png"),
          name: "电商推荐系统",
          txt: "推荐系统是数据挖掘领域的典型项目，也是目前主流互联网产品的标配。推荐系统通过对用户的兴趣建模，将用户感兴趣的内容排在前面，过滤掉用户不感兴趣的内容，从而实现业务核心指标（点击率、转化率等）的提升。项目中会讲解常用大数据框架（Hadoop、Hive、Spark）在数据分析与挖掘工作中的使用方法，并介绍召回排序算法、特征提取等推荐系统实践过程中的热点知识。",
          lightPoint:
            "· 学后可掌握在大数据场景下进行数据分析与数据挖掘等相关技术，能够胜任数据挖掘工程师的工作。",
        },
        {
          num: "项目三",
          img: require("../../../assets/coursePage/dataAnalysis/box8/1.png"),
          name: "娱乐数据爬取和可视化大屏展示",
          txt: "娱乐可视化大屏项目，将数据爬取、可视化大屏展示和后端服务搭建融合在一起。整个项目涵盖了数据可视化工程从数据获取到数据库，开发服务端数据接口到前端可视化展示的全部流程。",
          lightPoint:
            "· 熟练掌握此项目后可独立完成不同业务场景下的数据可视化工程项目。",
        },
      ],
      cur: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box5",
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  methods: {
  showPop(){
    this.show = true
      this.mai("数据开发-就业课","查看全部",0,this.projectList[this.cur].name)
    },
    slideChange() {
      this.cur = this.$refs.mySwiper.$el.swiper.realIndex;
    },
    changeCur(index) {
      this.swiper.slideTo(index, 0);

      this.cur = index;
    },
    close() {
      this.showVideo = false;
    },
  },
};
</script>

<style lang="less" scoped>
.box8 {
  padding: 80px 32px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box8/bgc.png")
    no-repeat;
  background-size: cover;
  overflow: hidden;
  box-sizing: border-box;
  .titleContent {
    margin: 0 auto 60px;
    width: 360px;
    height: 80px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0px 4px 20px 0px rgba(202, 211, 235, 0.3),
      inset 2px 2px 2px 0px #ffffff;
    border-radius: 48px;
    backdrop-filter: blur(16px);
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    display: flex;
    padding: 0 8px 0 48px;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    p {
      width: 176px;
      height: 64px;
      background: linear-gradient(270deg, #8192ff 0%, #a2aeff 100%);
      border-radius: 40px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 64px;
      text-align: center;
    }
  }
  .nav-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }

  .subject-box {
    position: relative;
    margin: 0px auto 0;
    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
    .swiperwrap {
      width: 686px;

      .img {
        width: 544px;
        height: 328px;
        object-fit: cover;
        border-radius: 16px;
        margin: 0 auto;
        display: block;
      }
      .projectName {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
        text-align: center;
        margin: 32px 0 16px;
      }
      .intro {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #5d76ff;
        line-height: 48px;
        margin-bottom: 16px;
        text-align: center;
      }
      .projectDesc {
        height: 88px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 44px;
        background: linear-gradient(180deg, #4b596b 0%, #f2f8fe 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .btn {
        margin-top: 24px;
        width: 252px;
        height: 68px;
        background: linear-gradient(270deg, #4ea0ff 0%, #4c26ff 100%);
        border-radius: 34px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 68px;
        text-align: center;
        margin: 24px auto 0;
      }
    }

    .nav-box {
      display: flex;
      justify-content: space-between;
      margin: 48px 0 48px;
      position: relative;
      font-family: PingFang SC;
      width: 100%;
      font-size: 24px;
      font-weight: 400;
      color: #1d2129;
      display: flex;
      justify-content: center;
      .nav {
        width: 138px;
        height: 68px;
        background: #ffffff;
        border-radius: 8px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 68px;
        text-align: center;
        margin-right: 20px;
      }

      .cur-nav {
        background: linear-gradient(207deg, #9194f8 0%, #775afd 100%);
        box-shadow: 0px 0px 36px 0px rgba(20, 50, 74, 0.04);

        font-weight: 600;
        color: #ffffff;
        position: relative;
      }
    }
  }

  .swiper-slide {
    .block {
      position: relative;
      margin: 0 auto;
      padding: 36px 32px;
      width: 686px;
      height: 688px;
      background: #ffffff;
      box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      border: 1px solid #ffffff;
      background-size: contain;
      background-repeat: no-repeat;
      // box-sizing: border-box;

      .open {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        width: 100%;
        height: 140px;
        // background: #fff;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 40%,
          #fff 100%
        );
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
        box-sizing: border-box;

        img {
          margin-left: 8px;
          width: 32px;
          height: 32px;
        }
      }

      overflow: hidden;
      box-sizing: border-box;

      .block-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        height: 56px;
        .title {
          font-size: 28px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #1d2129;
        }

        .play-btn {
          display: flex;
          align-items: center;
          width: 180px;
          height: 56px;
          background: linear-gradient(313deg, #1fd7cd 0%, #65bcff 100%);
          box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
          border-radius: 32px;

          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;

          .play {
            margin-left: 8px;
            margin-right: 12px;
            width: 40px;
            height: 40px;
            background-color: #ffffff;
            border-radius: 50%;
            box-shadow: 0px 0px 6px 0px #28a9ea;
            background-image: url("../../../assets/coursePage/ai/box8/play.png");
            background-size: 24px 24px;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .into {
        margin-bottom: 24px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
      }
    }
  }

  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 48px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      margin: 48px 0 32px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 40px;
    }
    .intro {
      margin: 16px 0 40px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      margin-bottom: 24px;
      width: 170px;
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      font-size: 28px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #2674ff;
      line-height: 56px;
    }

    .target {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 74px;
      p {
        text-indent: -23px;
        padding-left: 23px;
      }
    }
  }
}
</style>
